var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.organization)?_c('div',[_c('payment-method-form',{attrs:{"organization":_vm.organization,"payment-methods-url":"/customers/payment_methods"},on:{"success":function($event){return _vm.$emit('saved')},"cancel":function($event){return _vm.$emit('cancel')}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }